import {
  Field,
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { MdExpandMore } from "react-icons/md";
import { ORGANIZATION_TYPES } from "../utils/constants";

const OrganizationTypeSelect = ({
  label = "Organization Type",
  value,
  onChange,
  placeholder = "Select your organization type",
  buttonClassName = "",
}) => {
  const selected = ORGANIZATION_TYPES.find((type) => type.value === value);

  return (
    <Field>
      <Label className="block text-2xl font-bold text-white text-left atkinson-font">
        {label}
      </Label>
      <Listbox value={value ?? ""} onChange={onChange}>
        <div className="relative mt-2">
          {/* ! overrides are needed to beat the global `button` styles in the app CSS */}
          <ListboxButton
            className={`flex w-full items-center justify-between rounded-md !mr-0 !px-3 !border !border-solid !border-[#FFFFFFCC] !bg-[#595959] hover:!bg-[#595959] text-left text-[#FFFFFF] focus:!border-[#FFFFFF] focus:outline-none data-[open]:!border-[#FFFFFF] ${buttonClassName}`}
          >
            <span className={selected ? "" : "text-[#FFFFFFCC]"}>
              {selected ? selected.label : placeholder}
            </span>
            <MdExpandMore
              aria-hidden="true"
              className="text-xl text-white transition-transform duration-200 [[data-open]_&]:rotate-180"
            />
          </ListboxButton>
          <ListboxOptions className="absolute left-0 z-50 mt-1 max-h-60 w-full overflow-y-auto rounded-md bg-[#D9D9D9] p-2 shadow-xl focus:outline-none">
            {ORGANIZATION_TYPES.map((type) => (
              <ListboxOption
                key={type.value}
                value={type.value}
                className="cursor-pointer rounded-md px-6 py-2 text-left text-sm text-black atkinson-font tracking-tight data-[focus]:bg-purple-200 data-[selected]:!bg-[#5701AE] data-[selected]:text-white"
              >
                {type.label}
              </ListboxOption>
            ))}
          </ListboxOptions>
        </div>
      </Listbox>
    </Field>
  );
};

export default OrganizationTypeSelect;
